import { SERVER_API } from "../../Constant";
import axios from "axios";

export const FetchCities_api = async () => {
    try {
        const response = await axios.get(`${SERVER_API}/Dealers/fetch_cities.php`);
        return response.data;
    } catch (error) {
        console.error("Fetch cities failed:", error);
        return { error: "Fetch cities failed" };
    }
};

export const AddCity_api = async (payload: any) => {
    try {
        const formData = new FormData();
        formData.append("inputs", JSON.stringify(payload));
        const response = await axios.post(`${SERVER_API}/Dealers/add_city.php`, formData);
        return response.data;
    } catch (error) {
        console.error("Add city failed:", error);
        return { error: "Add city failed" };
    }
};

export const UpdateCity_api = async (payload: any) => {
    try {
        const formData = new FormData();
        formData.append("inputs", JSON.stringify(payload));
        const response = await axios.post(`${SERVER_API}/Dealers/update_city.php`, formData);
        return response.data;
    } catch (error) {
        console.error("Update city failed:", error);
        return { error: "Update city failed" };
    }
};

export const FetchDealers_api = async (page = 1, limit = 10, search = "") => {
    try {
        const response = await axios.get(`${SERVER_API}/Dealers/fetch_dealers.php`, {
            params: { page, limit, search }
        });
        return response.data;
    } catch (error) {
        console.error("Fetch dealers failed:", error);
        return { error: "Fetch dealers failed" };
    }
};

export const AddDealer_api = async (payload: any) => {
    try {
        const formData = new FormData();
        formData.append("inputs", JSON.stringify(payload));
        const response = await axios.post(`${SERVER_API}/Dealers/add_dealer.php`, formData);
        return response.data;
    } catch (error) {
        console.error("Add dealer failed:", error);
        return { error: "Add dealer failed" };
    }
};

export const UpdateDealer_api = async (payload: any) => {
    try {
        const formData = new FormData();
        formData.append("inputs", JSON.stringify(payload));
        const response = await axios.post(`${SERVER_API}/Dealers/update_dealer.php`, formData);
        return response.data;
    } catch (error) {
        console.error("Update dealer failed:", error);
        return { error: "Update dealer failed" };
    }
};

export const ChangeDealerStatus_api = async (payload: any) => {
    try {
        const formData = new FormData();
        formData.append("inputs", JSON.stringify(payload));
        const response = await axios.post(`${SERVER_API}/Dealers/update_dealer_status.php`, formData);
        return response.data;
    } catch (error) {
        console.error("Change status failed:", error);
        return { error: "Change status failed" };
    }
};

export const FetchDealerStock_api = async (dealer_id: number, status: string = 'available', page = 1, limit = 100) => {
    try {
        const response = await axios.get(`${SERVER_API}/Stock/fetch_dealer_stock.php`, {
            params: { dealer_id, status, page, limit }
        });
        return response.data;
    } catch (error) {
        console.error("Fetch dealer stock failed:", error);
        return { error: "Fetch dealer stock failed" };
    }
};
